const defaultOptions = {
  decimals: 2,
  symbol: false,
  currency: 'USD',
  style: true,
};

export default (value, options = defaultOptions) => {
  if (Number.isNaN(value)) {
    return '-';
  }

  if (isNaN(value)) {
    return value;
  }

  options = { ...defaultOptions, ...options };

  const formatter = new Intl.NumberFormat('es-AR', {
    style: options.style ? 'currency' : 'decimal',
    currency: 'USD',
    currencyDisplay: options.symbol ? 'symbol' : 'code',
    minimumFractionDigits: options.decimals,
  });

  return formatter.format(value);
};
